"use strict";

function basename(p) {
  var parts = p.split("/");
  return parts[parts.length - 1];
}
var _require$DocUtils = require("docxtemplater").DocUtils,
  str2xml = _require$DocUtils.str2xml,
  xml2str = _require$DocUtils.xml2str;
module.exports = function (relM) {
  function getTarget(i) {
    return "charts/chart".concat(i, ".xml");
  }
  function addChart(path, zipFiles) {
    var pathMap = {};
    var startI = path.replace(/.*chart([0-9]+).*/, "$1");
    var relsFile = path.replace("charts/", "charts/_rels/") + ".rels";
    var colorsFile = path.replace("charts/chart", "charts/colors");
    var styleFile = path.replace("charts/chart", "charts/style");
    var fileName;
    var i;
    i = 0;
    do {
      i++;
      fileName = "".concat(relM.ftprefix, "/").concat(getTarget(i));
    } while (relM.zip.files[fileName]);
    var chartContent = zipFiles[path].asBinary();
    relM.zip.file(fileName, chartContent, {
      binary: true
    });
    pathMap[path] = fileName;
    relM.addOverride("application/vnd.openxmlformats-officedocument.drawingml.chart+xml", "/".concat(fileName));
    if (zipFiles[relsFile]) {
      var relsContent = zipFiles[relsFile].asBinary();
      var replaces = [colorsFile, styleFile];
      replaces.forEach(function (from) {
        from = basename(from);
        relsContent = relsContent.replace(from, from.replace(startI, i));
      });
      var relsXml = str2xml(relsContent);
      var rels = relsXml.getElementsByTagName("Relationship");
      for (var j = 0, len = rels.length; j < len; j++) {
        var rel = rels[j];
        var type = rel.getAttribute("Type");
        if (type === "http://schemas.openxmlformats.org/officeDocument/2006/relationships/package") {
          var target = rel.getAttribute("Target").replace("..", "word");
          var newTarget = relM.getAvailablePath(target);
          pathMap[target] = newTarget;
          relM.zip.file(newTarget, zipFiles[target].asBinary(), {
            binary: true
          });
          rel.setAttribute("Target", "/".concat(newTarget));
          relM.addExtensionRels("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xlsx");
        }
      }
      relsContent = xml2str(relsXml);
      relsFile = fileName.replace("charts/", "charts/_rels/") + ".rels";
      pathMap[path.replace("charts/", "charts/_rels/") + ".rels"] = relsFile;
      relM.zip.file(relsFile, relsContent, {
        binary: true
      });
    }
    if (zipFiles[colorsFile]) {
      var colorsContent = zipFiles[colorsFile].asBinary();
      colorsFile = fileName.replace("charts/chart", "charts/colors");
      relM.zip.file(colorsFile, colorsContent, {
        binary: true
      });
      pathMap[path.replace("charts/chart", "charts/colors")] = colorsFile;
      relM.addOverride("application/vnd.ms-office.chartcolorstyle+xml", "/".concat(colorsFile));
    }
    if (zipFiles[styleFile]) {
      var styleContent = zipFiles[styleFile].asBinary();
      styleFile = fileName.replace("charts/chart", "charts/style");
      pathMap[path.replace("charts/chart", "charts/style")] = styleFile;
      relM.zip.file(styleFile, styleContent, {
        binary: true
      });
      relM.addOverride("application/vnd.ms-office.chartstyle+xml", "/".concat(styleFile));
    }
    relM.addExtensionRels("application/vnd.openxmlformats-package.relationships+xml", "rels");
    return {
      target: getTarget(i),
      pathMap: pathMap
    };
  }
  function addTheme(zipFiles) {
    var target = "theme/theme1.xml";
    var relationships = relM.relsDoc.getElementsByTagName("Relationships")[0];
    var themeFile = "word/theme/theme1.xml";
    if (!zipFiles[themeFile]) {
      return;
    }
    if (relM.zip.files[themeFile]) {
      return;
    }
    var themeContent = zipFiles[themeFile].asBinary();
    relM.zip.file(themeFile, themeContent, {
      binary: true
    });
    var themeTag = relM.relsDoc.createElement("Relationship");
    relM.setAttributes(themeTag, {
      Id: "rId".concat(relM.getNextRid()),
      Type: "http://purl.oclc.org/ooxml/officeDocument/relationships/theme",
      Target: target
    });
    relM.addOverride("application/vnd.openxmlformats-officedocument.theme+xml", "/word/theme/theme1.xml");
    relationships.appendChild(themeTag);
  }
  relM.addChart = function (path, zipFiles) {
    var _addChart = addChart(path, zipFiles),
      target = _addChart.target,
      pathMap = _addChart.pathMap;
    var relationships = relM.relsDoc.getElementsByTagName("Relationships")[0];
    var newTag = relM.relsDoc.createElement("Relationship");
    var rid = relM.getNextRid();
    relM.setAttributes(newTag, {
      Id: "rId".concat(rid),
      Type: "http://purl.oclc.org/ooxml/officeDocument/relationships/chart",
      Target: target
    });
    relationships.appendChild(newTag);
    addTheme(zipFiles);
    return {
      rId: "rId".concat(rid),
      pathMap: pathMap
    };
  };
  return relM;
};